import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setStrokeScaleConfigOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getStrokeScaleConfigOptions])
    const { entity } = response
    yield put(actions.setStrokeScaleConfigOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setStrokeScaleConfigOptions() error: ${e}`))
  }
}
export function* setStrokeScaleConfigOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setStrokeScaleConfigOptions)
}
